import AppWaldenViewDetailController from '../../walden-view/detail';

export default class AppServicesWaldenViewRefDetailController extends AppWaldenViewDetailController {}
